import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createQuotationEntry = createAsyncThunk('createQuotationEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=MultiInsertQuot`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateQuotationRate = createAsyncThunk('updateQuotationRate', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateQuotationRate`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchQuotatuionData = createAsyncThunk('fetchQuotatuionData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getQuotationlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchQuotNo = createAsyncThunk('fetchQuotNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getquotNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchQuotationNo = createAsyncThunk('fetchQuotationNo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getquotationNo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchQuotViewlist = createAsyncThunk('fetchQuotViewlist', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getQuotationViewlist&quotId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleQuotation = createAsyncThunk('deleteSingleQuotation', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteQuotation&quotId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const quotationSlice = createSlice({
    name: 'QuotationData',
    initialState: {
        isLoading: false,
        quotNo: null,
        quotationNo: null,
        quotData: null,
        Qviewlist: null,
        deleteQuot: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchQuotNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchQuotNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.quotNo = action.payload;
        });
        builder.addCase(fetchQuotNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchQuotationNo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchQuotationNo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.quotationNo = action.payload;
        });
        builder.addCase(fetchQuotationNo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchQuotatuionData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchQuotatuionData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.quotData = action.payload;
        });
        builder.addCase(fetchQuotatuionData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchQuotViewlist.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchQuotViewlist.fulfilled, (state, action) => {
            state.isLoading = false;
            state.Qviewlist = action.payload;
        });
        builder.addCase(fetchQuotViewlist.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleQuotation.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleQuotation.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteQuot = action.payload;
        });
        builder.addCase(deleteSingleQuotation.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default quotationSlice.reducer;
